import React from 'react';

import { Select } from '@aline/common';
import { Stack, Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { makeStyles } from 'tss-react/mui';

import type { CommentPanelComment } from './CommentsDrawer';

const useStyles = makeStyles()(_theme => ({
  importedText: {
    fontStyle: 'italic',
  },
}));

interface CommentSubHeaderProps {
  comment: CommentPanelComment;
  isRootCommentResolved: boolean;
}

export function CommentSubHeader({
  comment,
  isRootCommentResolved,
}: CommentSubHeaderProps): JSX.Element {
  const { classes } = useStyles();
  const commentTime = format(parseISO(comment.createdAt), 'MMM d yyyy h:mm a');
  const subheader = `${commentTime}${isRootCommentResolved ? ' (resolved)' : ''}`;

  if (comment.importedAuthorName) {
    return (
      <Stack>
        <Typography color="textSecondary" variant="caption">
          {subheader}
        </Typography>
        <Typography className={classes.importedText} color="textSecondary" variant="caption">
          From imported document
        </Typography>
      </Stack>
    );
  }

  return (
    <Typography
      data-cy={Select.document.editor.rightDrawer.comments.commentBoxCard.subheader}
      variant="caption"
    >
      {subheader}
    </Typography>
  );
}
